import appendSlide from './appendSlide';
import prependSlide from './prependSlide';
import addSlide from './addSlide';
import removeSlide from './removeSlide';
import removeAllSlides from './removeAllSlides';
export default {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/manipulation/index.js
// module id = 1172
// module chunks = 168